import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import SubMenuView from '../../views/subMenuView';
import ChannelConfig from './channel-config';
import MassUnit from './mass-unit';
import SetDeviceTag from './set-deviceTN';

function ConfigUnits() {
  const yesNoItem = [
    {id: 1, name: 'Yes', component: <MassUnit />},
    {id: 2, name: 'No', component: <ChannelConfig />},
  ];

  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  // const leftPress = useKeyPress('ArrowLeft');
  // const {onComponent} = useMenu();

  // useEffect(() => {
  //   if (!leftPress || isKeypressDisabled) return;

  //   // onComponent(<SetDeviceTag />);
  // }, [leftPress]);

  // useEffect(() => {
  //   if (!initiallyDisableKeypress) return;

  //   setTimeout(() => {
  //     setIsKeypressDisabled(false);
  //   }, 500);
  // }, []);

  return (
    <SubMenuView
      title="Configure Units"
      menuItems={yesNoItem}
      content="Do you want to configure units?"
      isMenuDisabled
      onLeftCallback={() => onComponent(<SetDeviceTag />)}
    />
  );
}
export default ConfigUnits;
